'use es6';

import Availability from 'MeetingsBase/models/Availability';
import { ZERO_DURATION } from 'MeetingsBase/constants/dates';
import { START_TIME_INTERVALS } from 'MeetingsBase/constants/enums';
import { List } from 'immutable';
import I18n from 'I18n';
import DisplayInfo from 'MeetingsBase/models/DisplayInfo';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
export var DEFAULT_HTTP_TIMEOUT_IN_MS = 15000;
export var DEFAULT_LINK_CUSTOM_PARAMS = {
  activityType: null,
  availability: new Availability(),
  // only used to store selected time options while editing meeting links
  availabilityTimeList: List(),
  customAvailabilityStartDate: null,
  customAvailabilityEndDate: null,
  description: null,
  displayInfo: new DisplayInfo(),
  welcomeScreenInfo: new WelcomeScreenInfo(),
  durations: new List([ZERO_DURATION]),
  formFields: List(),
  includeDescriptionInReminder: false,
  language: null,
  recaptchaEnabled: false,
  legalConsentEnabled: false,
  legalConsentOptions: null,
  locale: null,
  location: null,
  meetingBufferTime: I18n.moment.duration('00:15:00').asMilliseconds(),
  ownerPrioritized: false,
  minimumNoticeTime: I18n.moment.duration('00:15:00').asMilliseconds(),
  redirectUrl: null,
  reminders: List(),
  sendReminder: false,
  shouldAutoSubmit: false,
  shouldPrefillFormFields: true,
  subject: null,
  timezone: 'Europe/Dublin',
  videoConferenceExtensionAppId: null,
  videoConferenceExtensionAccountId: null,
  weeksToAdvertise: 2,
  startTimeIncrementMinutes: START_TIME_INTERVALS.FIFTEEN,
  confirmationEmailEnabled: true,
  pushBackTime: I18n.moment.duration('00:15:00').asMilliseconds()
};